export const paths = {
    HOME: '/',
    AUTH: '/auth',
    LOGIN: '/login',
    CONFIGURE_PROFILE: '/register/configure',
    NOT_FOUND: '/not-found',
    SYSTEM: '/system',
    IMPORT_PROSPECTS: '/system/import-prospects',
    ACCOUNT_MANAGEMENT: '/account-management',
    ACCOUNTS: '/accounts',
    PROSPECTING: '/prospecting',
    SEARCH: '/prospecting/search',
    IMPORT_CSV_PROSPECTS: '/prospecting/import-prospects',
    PROSPECT_COLLECTIONS: '/lists',
};
